import { render, staticRenderFns } from "./PrivateSale.vue?vue&type=template&id=50699c2b&"
import script from "./PrivateSale.vue?vue&type=script&lang=js&"
export * from "./PrivateSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports